var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"table-header"},[(_vm.name)?_c('h2',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('div',{staticClass:"header-media"},[_vm._t("btn"),_c('span',{attrs:{"i-class":"text-primary"}},[_vm._v(_vm._s(_vm.decs))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }